module.exports = __webpack_public_path__ + "static/img/photo-boards-J9vZCx-OX1Q-unsplash_thumb.db7d7b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/photo-boards-J9vZCx-OX1Q-unsplash_thumb.png
// module id = Gp/t
// module chunks = 4